export default __webpack_public_path__ + "static/media/regulatory--no-horizontal-turn--g1.ab7eda4b.png";